import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 15000,
  withCredentials: true,
});

export const listTutors = (params = {}) => api.get("/tutors", { params }).then((r) => r.data);
export const listAllTutors = () => api.get("/panel/tutors").then((r) => r.data);
export const getTutor = (id) => api.get(`/tutors/${id}`).then((r) => r.data);
export const createTutor = (payload) => api.post("/panel/tutors", payload).then((r) => r.data);
export const updateTutor = (id, payload) => api.patch(`/panel/tutors/${id}`, payload).then((r) => r.data);
export const deleteTutor = (id) => api.delete(`/panel/tutors/${id}`).then((r) => r.data);
export const listSessions = (params = {}) => api.get("/sessions", { params }).then((r) => r.data);
export const listDemoProgress = () => api.get("/demo-progress").then((r) => r.data);
export const createSession = (payload) => api.post("/sessions", payload).then((r) => r.data);
export const adminStats = () => api.get("/admin/stats").then((r) => r.data);
export const getAvailability = () => api.get("/availability").then((r) => r.data);
export const createBooking = (payload) => api.post("/bookings", payload).then((r) => r.data);
export const markBookingReturned = (id) => api.post(`/bookings/${id}/returned`).then((r) => r.data);
export const listBookings = () => api.get("/panel/bookings").then((r) => r.data);
export const confirmBooking = (id) => api.post(`/panel/bookings/${id}/confirm`).then((r) => r.data);
export const releaseBooking = (id) => api.post(`/panel/bookings/${id}/release`).then((r) => r.data);
export const createContact = (payload) => api.post("/contacts", payload).then((r) => r.data);
export const createContactsSession = (payload) => api.post("/contacts/session", payload).then((r) => r.data);
export const getContactsSessionStatus = () => api.get("/contacts/session/status").then((r) => r.data);
export const listContacts = () => api.get("/contacts").then((r) => r.data);
export const markContactSent = (id) => api.post(`/contacts/${id}/mark-sent`).then((r) => r.data);
export const contactDeliveryUrl = (id, channel) => `${API}/contacts/${id}/delivery/${channel}`;
export const contactsCsvUrl = () => `${API}/contacts/export.csv`;
